import DataTable from './../DataTable'
import EventBus from '@/EventBus'
export default {
  mixins: [DataTable],
  methods: {
    privateLinkMode(props) {
      if(!this.config.linkMode) { return null }
      let result = this.R.clone(this.config.linkMode.route)
      for(let key in result.query) {
        result.query[key] = eval(result.query[key])
        result.params[key] = eval(result.params[key])
      }
      return result
    },
    routeDetail(props) {
      if(this.config.linkMode) {
        let to = this.privateLinkMode(props)
        if(to && props.row.hasOwnProperty(this.config.linkMode.clickAbleProps)) {
          this.$router.push(to)
          EventBus.$emit('reloadPage', null)
        }
      }
    }
  },
}
